import { useState, type FormEvent } from 'react';
import { api, mensajeDe, type Categoria, type ParejaAdmin } from '../../services/api';
import { Aviso, Boton, Campo, ENTRADA } from '../../components/ui';
import { LARGO_MAXIMO_PREMIO, NOMBRE_PUESTO, PUESTOS, type Puesto } from '../../nucleo/podio';

/**
 * Qué se lleva cada puesto. El organizador escribe un texto por puesto; quién
 * se lo lleva no se carga: sale del cuadro y aparece solo en la página pública.
 */
export function FormPremios({ categoria, recargar }: { categoria: Categoria<ParejaAdmin>; recargar: () => Promise<void> }) {
  const guardado = (p: Puesto) => categoria.premios.find((x) => x.puesto === p)?.descripcion ?? '';
  const [abierto, setAbierto] = useState(false);
  const [textos, setTextos] = useState<Record<Puesto, string>>({ 1: guardado(1), 2: guardado(2), 3: guardado(3) });
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    setEnviando(true);
    setError('');
    try {
      await api.guardarPremios(categoria.id, textos);
      setAbierto(false);
      await recargar();
    } catch (err) {
      setError(mensajeDe(err));
    } finally {
      setEnviando(false);
    }
  };

  if (!abierto) {
    return (
      <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1">
        <Boton chico tipo="secundario" onClick={() => setAbierto(true)}>
          {categoria.premios.length ? 'Cambiar premios' : 'Cargar premios'}
        </Boton>
        {categoria.premios.length > 0 && (
          <span className="text-xs text-(--color-apagado)">
            {categoria.premios.map((p) => `${p.puesto}º ${p.descripcion}`).join(' · ')}
          </span>
        )}
      </div>
    );
  }

  return (
    <form onSubmit={enviar} className="mt-4 flex flex-col gap-3 rounded-xl border border-(--color-borde) p-3">
      <p className="text-sm text-(--color-apagado)">
        Qué se lleva cada puesto. Dejá vacío el que no tenga premio. Los nombres aparecen solos en la página cuando se juega el partido que
        los define.
      </p>
      {PUESTOS.map((p) => (
        <Campo key={p} etiqueta={`${p}º · ${NOMBRE_PUESTO[p]}`}>
          <input
            className={ENTRADA}
            value={textos[p]}
            maxLength={LARGO_MAXIMO_PREMIO}
            onChange={(e) => setTextos({ ...textos, [p]: e.target.value })}
            placeholder={p === 1 ? '2 paletas + trofeo' : p === 2 ? 'Bolsos + medallas' : 'Tubos de pelotas'}
          />
        </Campo>
      ))}
      {error && <Aviso tono="error">{error}</Aviso>}
      <div className="flex gap-2">
        <Boton chico type="submit" deshabilitado={enviando}>
          {enviando ? 'Guardando...' : 'Guardar premios'}
        </Boton>
        <Boton chico tipo="secundario" onClick={() => setAbierto(false)}>
          Cancelar
        </Boton>
      </div>
    </form>
  );
}
